import Swiper from 'swiper';
import {Autoplay, Pagination, Keyboard, A11y,} from 'swiper/modules';

import {connect} from "../../../JavaScript/Utils";

const ViewTracking = new WeakMap();

/**
 *
 * @param list {NodeList}
 */
const trackView = (list) => {
    for (const el of list) {
        if (!ViewTracking.has(el)) {
            // console.log("track", el);
            ViewTracking.set(el, true);

            const url = new URL(window.location.href);
            url.searchParams.append('viewBanner', el.getAttribute('data-id'));
            fetch(url.toString(), {
                method: 'POST'
            });
        }
    }
}

class ProfinetBanner {
    /**
     *
     * @param element {HTMLElement}
     */
    constructor(element) {
        this.root = element;
        this.randomizeListItems(this.root.querySelector('.swiper-wrapper'));

        this.sliderInstance = new Swiper(this.root, {
            modules: [Keyboard, A11y, Autoplay, Pagination],
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: {
                delay: element.getAttribute('data-swiper-autoplay-delay'),
                pauseOnMouseEnter: true,
            },
            spaceBetween: 10,
            slidesPerView: 1,
            breakpoints: {
                992: {
                    spaceBetween: 40,
                    slidesPerView: 3,
                }
            },
            watchSlidesProgress: true,
            on: {
                progress(swiper, progress) {
                    const list = swiper.el.querySelectorAll('.swiper-slide-visible');
                    const currentBp = swiper.currentBreakpoint;
                    const slidesPerView = swiper.params.breakpoints[currentBp]?.slidesPerView ?? swiper.params.slidesPerView;
                    // only track if really visible
                    if (list.length === slidesPerView) {
                        trackView(list);
                        // edge case: less than slidesPerView
                    } else if (list.length === swiper.el.querySelectorAll('.swiper-slide').length) {
                        trackView(list);
                    }
                },
            }
        })
    }

    /**
     *
     * @param list {HTMLElement}
     */
    randomizeListItems(list) {
        for (let i = list.children.length; i >= 0; i--) {
            list.appendChild(list.children[Math.random() * i | 0]);
        }
    }

}

connect('.profinet-banner', ProfinetBanner)
